import Keycloak from "keycloak-js";
import Cookies from "js-cookie";

const keycloak = new Keycloak({
    url: process.env.REACT_APP_KC_SERVER_URL,
    realm: process.env.REACT_APP_KC_REALM_ID,
    clientId: process.env.REACT_APP_KC_CLIENT_ID,
    onLoad: 'login-required',
    checkLoginIframe: false
});
keycloak.onTokenExpired = () => {
    /*
    * 30 seconds before token expiration, update token
     */
    keycloak.updateToken(30).success(() => {
        Cookies.set('KEYCLOAK_SESSION', keycloak.token, {sameSite: 'strict'})
    }).catch(error => {
        Cookies.remove('KEYCLOAK_SESSION', {path: ''})
        // eslint-disable-next-line no-console
        console.log('keycloak token update error', error);
    });
}

export const initKeycloak = async () => {
    /*
    * Init keycloak and set user as local storage
    */
    await keycloak.init({onLoad: 'login-required', checkLoginIframe: false, flow: 'implicit'}).then(() => {
        // set user as local storage
        window.localStorage.setItem("automl-uid", keycloak.idTokenParsed.preferred_username);
        // set session cookie
        Cookies.set('KEYCLOAK_SESSION', keycloak.token, {sameSite: 'strict'})
    }).catch(error => {
        // eslint-disable-next-line no-console
        console.log('keycloak error', error);
    });
}
export const logoutKeycloakUser = async () => {
    Cookies.remove('KEYCLOAK_SESSION', {path: ''})
    window.localStorage.removeItem("automl-uid")
    keycloak.logout()
}

export const getJWT = async () => {
    if (Cookies.get('KEYCLOAK_SESSION')) {
        return Cookies.get('KEYCLOAK_SESSION')
    }
    await keycloak.init({onLoad: 'login-required', checkLoginIframe: false}).then(() => {
        Cookies.set('KEYCLOAK_SESSION', keycloak.token, {sameSite: 'strict'})
    }).catch(error => {
        // eslint-disable-next-line no-console
        console.log('keycloak error', error);
    });
    return keycloak.token;

}
